import { CheckCircle2, AlertTriangle, Info } from "lucide-react";

export const StoryContextStatus = ({ knowledge }) => {
  if (!knowledge) return null;

  const items = [];
  if (knowledge.characters > 0) items.push(`${knowledge.characters} character${knowledge.characters === 1 ? "" : "s"}`);
  if (knowledge.has_story_bible) items.push("Story Bible");
  if (knowledge.outline_chapters > 0) items.push(`${knowledge.outline_chapters}-chapter outline`);
  if (knowledge.chapters_written > 0) items.push(`${knowledge.chapters_written} chapter${knowledge.chapters_written === 1 ? "" : "s"} written`);
  if (knowledge.open_plot_threads > 0) items.push(`${knowledge.open_plot_threads} open plot thread${knowledge.open_plot_threads === 1 ? "" : "s"}`);
  if (knowledge.planned_reveals > 0) items.push(`${knowledge.planned_reveals} planned reveal${knowledge.planned_reveals === 1 ? "" : "s"}`);
  if (knowledge.locked_canon > 0) items.push("Canon rules");

  const memoryOk = knowledge.memory_status === "current";

  return (
    <div className="rounded-lg border border-slate-700/60 bg-slate-800/40 p-3" data-testid="architect-context-status">
      <p className="text-[11px] uppercase tracking-widest text-slate-400 mb-2">Story knowledge available</p>
      <div className="flex flex-wrap gap-x-4 gap-y-1.5">
        {items.map((label) => (
          <span key={label} className="flex items-center gap-1.5 text-xs text-slate-200">
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" /> {label}
          </span>
        ))}
        <span className="flex items-center gap-1.5 text-xs text-slate-200">
          {memoryOk ? (
            <CheckCircle2 className="w-3.5 h-3.5 text-emerald-400 shrink-0" />
          ) : (
            <Info className="w-3.5 h-3.5 text-amber-400 shrink-0" />
          )}
          {memoryOk ? "Story Memory current" : "Story Memory " + knowledge.memory_status}
        </span>
      </div>
      {!memoryOk && (
        <p className="mt-2 flex items-start gap-1.5 text-[11px] text-amber-300/90" data-testid="architect-memory-warning">
          <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
          {knowledge.memory_detail}
        </p>
      )}
    </div>
  );
};
